import { FC } from "react";
import styled from "styled-components";
import css from "@styled-system/css";

import Card from "../Card/Card";
import Box from "../Box/Box";
import Typography from "../Typography/Typography";
import LazyImage from "../Image/LazyImage";
import Button from "../Button/Button";
import { LayoutProps } from "styled-system";

const StyledCard = styled(Card)`
  overflow: hidden;
  img {
    transition: all 0.5s;
    transform: scale(1);
  }
  @media (hover: hover) {
    ${css({
      "&:hover img": {
        transform: "scale(1.1)",
      },
      "&:focus-within img": {
        transform: "scale(1.1)",
      },
    })};
  }
  ${css({
    p: 0,
    m: 0,
    display: "flex",
    flexDirection: "column",
  })};
`;

interface CardContent {
  headline: string;
  description: string;
  image?: { url: string; alt: string };
  moreInfo?: {
    label: string;
    visible: boolean;
  };
  isWideCard?: boolean;
  width?: LayoutProps["width"];
  height?: LayoutProps["height"];
}

const HalfImageCard: FC<CardContent> = ({
  headline,
  description,
  image,
  moreInfo,
  isWideCard,
  width = isWideCard ? { _: 300, tablet: 460 } : 300,
  height = "100%",
}) => (
  <StyledCard
    width={width}
    height={height}
    variant="hoverable"
    aria-label={isWideCard ? "half image wide card" : "half image card"}
  >
    {image && (
      <LazyImage
        src={image.url}
        alt={image.alt}
        height={"auto"}
        css={`
          max-height: 208px;
          & img {
            height: auto;
          }
        `}
      ></LazyImage>
    )}
    <Box px={6} pt={6} pb={4} height="auto">
      <Typography
        variant="h5"
        textAlign="left"
        color="text-color"
        css={`
          margin: 0px;
        `}
      >
        {headline}
      </Typography>
      <Typography
        variant="body"
        color="lighter-text-color"
        textAlign="left"
        p={0}
        mt={2}
        mb={0}
        css={`
          line-height: 1.36;
          min-height: 57px;
        `}
      >
        {description}
      </Typography>
    </Box>
    <Box px={6} mt="auto" mb={6}>
      {moreInfo && moreInfo.visible && (
        <Button
          height="auto"
          variant="tertiary"
          text={moreInfo.label}
          width="fit-content"
          textAlign="start"
          p={0}
        />
      )}
    </Box>
  </StyledCard>
);

export default HalfImageCard;
